<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
  <v-card class="lighten-4 pa-3" dark color="rgba(29,27,65,.6)" style="height:100%;">
    <v-row>
      <v-col cols="12" class="pt-0">
        <v-radio-group row :hide-details="true" v-model="graphSelected" class="mt-0" dense>
          <v-radio label="Cases" value="cases" color="pink" style="font-weight: 300;"></v-radio>
          <v-radio label="Daily Increase" value="daily" color="pink" style="font-weight: 300;"></v-radio>
          <v-radio
            label="Confirmed Per Province"
            value="casesprov"
            color="pink"
            style="font-weight: 300;"
          ></v-radio>
          <!-- <v-radio label="Tests Per Province" value="testsprov" color="pink" style="font-weight: 300;"></v-radio> -->
          <v-radio label="Tests in SA" value="tests" color="pink" style="font-weight: 300;"></v-radio>
          <!-- <v-radio
            label="Hotspot Regions"
            value="regions"
            color="pink"
            style="font-weight: 300;"
          ></v-radio>  -->
          <v-radio
            label="SA Compared to World"
            value="global"
            color="pink"
            style="font-weight: 300;"
          ></v-radio>
          <v-radio
            label="SA Compared to Africa"
            value="africa"
            color="pink"
            style="font-weight: 300;"
          ></v-radio>   
          <v-radio
            label="Vaccines"
            value="vaccines"
            color="pink"
            style="font-weight: 300;"
          ></v-radio>       
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0 pb-0">
        <Cases v-show="graphSelected === 'cases'" ref="Cases"></Cases>
        <Daily v-show="graphSelected === 'daily'" ref="Daily"></Daily>
        <GlobalComp v-show="graphSelected === 'global'" ref="GlobalComp"></GlobalComp>
        <AfricaComp v-show="graphSelected === 'africa'" ref="AfricaComp"></AfricaComp>
        <CasesSAProv v-show="graphSelected === 'casesprov'" ref="CasesSAProv"></CasesSAProv>        
        <Tests v-show="graphSelected === 'tests'" ref="Tests"></Tests>
        <TestsProv v-show="graphSelected === 'testsprov'" ref="TestsProv"></TestsProv>
        <Regions v-show="graphSelected === 'regions'" ref="Regions"></Regions>
        <Vaccines v-show="graphSelected === 'vaccines'" ref="Vaccines"></Vaccines>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import Cases from "@/components/graphs/Cases.vue";
import Daily from "@/components/graphs/Daily.vue";
import GlobalComp from "@/components/graphs/GlobalComp.vue";
import AfricaComp from "@/components/graphs/AfricaComp.vue";
import Tests from "@/components/graphs/Tests.vue";
import CasesSAProv from "@/components/graphs/CasesSAProv.vue";
import TestsProv from "@/components/graphs/TestsProvs.vue";
import Regions from "@/components/graphs/Regions.vue";
import Vaccines from "@/components/graphs/Vaccines.vue";

export default {
  name: "Graph",
  components: {
    Cases,
    Daily,
    GlobalComp,
    AfricaComp,
    Tests,
    CasesSAProv,
    TestsProv,
    Regions,
    Vaccines
  },
  data: () => ({
    casesData: [],
    graphSelected: "cases",
    provinceSelected: ""
  }),
  watch: {
    graphSelected: function(val) {
      //resize the graphs
      if (val === "cases") {
        //load the graph data
        this.$refs.Cases.loadCases(
          this.casesData,
          this.provinceSelected
        );
        
        this.$refs.Cases.resize();
      } else if (val === "daily") {
        //load the graph data
        this.$refs.Daily.loadCases(
          this.casesData,
          this.provinceSelected
        );

        this.$refs.Daily.resize();
      } else if (val === "global") {
        this.$refs.GlobalComp.resize();
      } else if (val === "africa") {
        this.$refs.AfricaComp.resize();
      } else if (val === "tests") {
        this.$refs.Tests.loadCases(
          this.casesData
        );
        
        this.$refs.Tests.resize();
      } else if (val === "casesprov") {
        //load the graph data
        this.$refs.CasesSAProv.loadCases(
          this.casesData,
          this.provinceSelected
        );
        
        this.$refs.CasesSAProv.resize();
      } else if (val === "testsprov") {
        this.$refs.TestsProv.loadCases(
          this.casesData
        );
        
        this.$refs.TestsProv.resize();
      } else if (val === "regions") {
        this.$refs.Regions.loadCases(
          this.casesData,
          this.provinceSelected
        );
        
        this.$refs.Regions.resize();
      } else if (val === "vaccines") {
        this.$refs.Vaccines.loadCases(
          this.casesData,
          this.provinceSelected
        );
        
        this.$refs.Vaccines.resize();
      }

      //post the GA
      gtag("event", "graph", {
        event_category: val,
        'send_to': 'UA-161523063-1'
      });
    }
  },
  methods: {
    loadCases(data, provinceDisplay) {
      this.casesData = data;
      this.provinceSelected = provinceDisplay;

      //load the graph data
      if (this.graphSelected === "cases") {
        this.$refs.Cases.loadCases(
          this.casesData,
          this.provinceSelected
        );
      }
      else if (this.graphSelected === "daily") {
        this.$refs.Daily.loadCases(
          this.casesData,
          this.provinceSelected
        );
      } 
     else if (this.graphSelected === "casesprov") {
       this.$refs.CasesSAProv.loadCases(
          this.casesData,
          this.provinceSelected
        );
     }   
     else if (this.graphSelected === "tests") {
       this.$refs.Tests.loadCases(
          this.casesData
        );
     }
     else if (this.graphSelected === "testsprov") {
       this.$refs.TestsProv.loadCases(
          this.casesData
        );
     }    
     else if (this.graphSelected === "regions") {
       this.$refs.Regions.loadCases(
          this.casesData,
          this.provinceSelected
        );
     } 
     else if (this.graphSelected === "vaccines") {
       this.$refs.Vaccines.loadCases(
          this.casesData,
          this.provinceSelected
        );
     }     
      
    },
    loadInterventions(data) {
      //load the graph data
      this.$refs.Cases.loadInterventions(data);
      this.$refs.Tests.loadInterventions(data);
      this.$refs.Daily.loadInterventions(data);    
    },
    loadGlobalStats(confirmedData, continents) {
      //load the graph data
      this.$refs.GlobalComp.loadGlobalStats(confirmedData, continents);
      this.$refs.AfricaComp.loadGlobalStats(confirmedData, continents);
    }
  }
};
</script>
